import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pf0024',
    ecrans: ['00-2'],
    params: ['id',
             '?suacleint',
             '?stamnetab']
});
